$(document).ready(function () {
  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();

    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function () {
      $(element).html(oldValue);
    }, 300);
    $temp.remove();
  }

  $("cupom").click(function () {
    copyToClipboard(this);
  });

  // SLIDE INSTAGRAM STORIES HOME
  if ($(".ig-stories-wrapper").length) {
    $(".ig-stories-wrapper").slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<svg class="icon" viewBox="0 0 407.436 407.436"> <polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 " /> </svg>',
      nextArrow:
        '<svg class="icon" viewBox="0 0 407.436 407.436"> <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 " /> </svg>',
      infinite: false,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $("[data-fancybox]").on("click", function (event) {
      var target = $(event.target);
      var link = target.closest(".direct-link").attr("href");

      // Verificar se o destino do clique tem a classe .product-link
      if (target.closest(".direct-link").length > 0) {
        event.preventDefault(); // Prevenir o comportamento padrão do clique
        // Faça aqui o que você deseja quando um elemento .product-link for clicado
        window.location.href = link;
        console.log("Clicou em um .direct-link");
      }
    });
  }

  // SLIDE BLOG HOME
  if ($(".content-block.main-blog-view").length) {
    $(".content-block.main-blog-view").slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      prevArrow:
        '<svg class="icon" viewBox="0 0 407.436 407.436"> <polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718 " /> </svg>',
      nextArrow:
        '<svg class="icon" viewBox="0 0 407.436 407.436"> <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 " /> </svg>',
      infinite: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }
});
